import { useEffect, useState } from "react";
import { Grid, TextField, Select, MenuItem } from "../../../../components";
import {
  ColecoesService,
  MarcasService,
  SessionService,
} from "../../../../services";
import { responseErros } from "../../../../utils";
import { value } from "../../../../helpers";
import { Autocomplete } from "@mui/material";

const FormFiltroAvancado = ({
  valueInput,
  onChangeInput,
  onChangeMultiple,
}) => {
  const marcasService = new MarcasService();
  const colecoesService = new ColecoesService();
  const empresa = new SessionService().getEmpresa();
  const [marcas, setMarcas] = useState([]);
  const [colecoes, setColecoes] = useState([]);

  useEffect(() => {
    buscarMarcas();
    buscarColecoes();
  }, []);

  const buscarMarcas = async function (filter) {
    const result = await marcasService.getAll(filter);
    if (!result.isAxiosError) {
      setMarcas(result.data.rows);
    } else {
      responseErros(result);
    }
  };

  const buscarColecoes = async function (filter) {
    const result = await colecoesService.getAll(filter);
    if (!result.isAxiosError) {
      setColecoes(result.data.rows);
    } else {
      responseErros(result);
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          id="codigo"
          name="codigo"
          label="Código"
          variant="outlined"
          fullWidth
          onChange={(event) => onChangeInput(event)}
          value={valueInput("codigo")}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          id="codigoBarra"
          name="codigoBarra"
          label="Código Barras"
          variant="outlined"
          fullWidth
          onChange={(event) => onChangeInput(event)}
          value={valueInput("codigoBarra")}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          id="descricao"
          name="descricao"
          label="Descrição"
          variant="outlined"
          fullWidth
          onChange={(event) => onChangeInput(event)}
          value={valueInput("descricao")}
        />
      </Grid>
      {empresa?.moduloServico && (
        <Grid item xs={12}>
          <TextField
            id="referenciaPeca"
            name="referenciaPeca"
            label="Referência da Peça"
            variant="outlined"
            fullWidth
            onChange={(event) => onChangeInput(event)}
            value={valueInput("referenciaPeca")}
          />
        </Grid>
      )}
      <Grid item xs={12}>
        <Select
          id="tipo"
          name="tipo"
          variant="outlined"
          label="Tipo"
          fullWidth
          onChange={(event) => onChangeInput(event)}
          value={valueInput("tipo")}
        >
          <MenuItem value="simples">Simples</MenuItem>
          <MenuItem value="grade">Grade</MenuItem>
          <MenuItem value="kit">Kit</MenuItem>
        </Select>
      </Grid>
      <Grid item xs={12}>
        <Autocomplete
          multiple
          id="marcasId"
          name="marcasId"
          options={marcas}
          noOptionsText="Sem opções"
          autoHighlight
          filterSelectedOptions
          getOptionLabel={(option) => option?.nome || ""}
          onChange={(_, newValue) => onChangeMultiple(newValue, "marcasId")}
          value={value.multiple(marcas, valueInput("marcasId"))}
          renderInput={(params) => (
            <TextField {...params} variant="outlined" label="Marcas" />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <Autocomplete
          multiple
          id="colecoesId"
          name="colecoesId"
          options={colecoes}
          noOptionsText="Sem opções"
          autoHighlight
          filterSelectedOptions
          getOptionLabel={(option) => option?.descricao || ""}
          onChange={(_, newValue) => onChangeMultiple(newValue, "colecoesId")}
          value={value.multiple(colecoes, valueInput("colecoesId"))}
          renderInput={(params) => (
            <TextField {...params} variant="outlined" label="Coleções" />
          )}
        />
      </Grid>
    </Grid>
  );
};

export default FormFiltroAvancado;
